import React, { createContext, useContext, useState } from "react";

// Создаём контекст
const SelectionContext = createContext();

// Провайдер контекста
export const SelectionProvider = ({ children }) => {
    const [selection, setSelection] = useState({}); // Храним объект с данными

    // Функция для обновления конкретного ключа
    const updateSelection = (key, value) => {
        setSelection((prev) => ({
            ...prev, // Копируем старые данные
            [key]: value, // Обновляем или добавляем новое поле
        }));
    };

    return (
        <SelectionContext.Provider value={{ selection, updateSelection }}>
            {children}
        </SelectionContext.Provider>
    );
};

// Хук для удобного использования контекста
export const useSelection = () => {
    return useContext(SelectionContext);
};